// Convenience hook returning the signed-in user's display data.

import { useAuth } from './useAuth';

export interface AdminDisplayUser {
  uid: string;
  email: string;
  displayName: string | null;
  photoURL: string | null;
}

export function useUser(): AdminDisplayUser | null {
  const { user } = useAuth();
  if (!user || !user.email) return null;
  return {
    uid: user.uid,
    email: user.email,
    displayName: user.displayName,
    photoURL: user.photoURL,
  };
}
